module.exports = __webpack_public_path__ + "static/media/dorsa-vi-logo.e4d07c88.png";